import authReducer from './authReducer'
import examReducer from './examReducer'

import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        auth: authReducer,
        exam: examReducer
    }
})
export default store